module.exports = __webpack_public_path__ + "img/popup_bussiness_pay_head.4aa646db.png";